/* The Lakhovsky Disc page (spirad.com, Elixir layout): the mockup's behaviour
   (gallery, tiers shared by the buy box, the sticky bar and the packages block,
   sticky on scroll) plus the store: the selected tier's variant goes to the cart
   with the gift property, then Elixir's cart drawer opens; delivery date and
   launch deadline computed live. Edit the mockup first, then this file. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  /* gallery */
  var slides = $$('#gmain .slide'), thumbs = $$('#thumbs button'), cur = 0;
  function show(i) {
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === cur); });
    var gi = $('#gidx'); if (gi) gi.textContent = cur + 1;
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  $$('.g-arrow').forEach(function (b) { b.addEventListener('click', function () { show(cur + +b.dataset.dir); }); });
  var gm = $('#gmain'), x0 = null;
  if (gm) {
    gm.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gm.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* tiers: buy box, sticky segment and packages block share one selection */
  var tiers = $$('.tier'), sel = null;
  function pick(k) {
    var t = tiers.filter(function (x) { return x.dataset.k == k; })[0]; if (!t) return;
    sel = t;
    tiers.forEach(function (x) { x.classList.toggle('sel', x === t); var i = $('input', x); if (i) i.checked = x === t; });
    $$('.js-price').forEach(function (e) { e.textContent = t.dataset.price; });
    $$('#gifts .gift').forEach(function (g) { g.classList.toggle('locked', +k < +g.dataset.need); });
    $$('#seg button').forEach(function (b) { b.classList.toggle('on', b.dataset.k == k); });
    $$('#pk .pkc').forEach(function (c) { c.classList.toggle('sel', c.dataset.k == k); });
  }
  tiers.forEach(function (t) { t.addEventListener('click', function () { pick(t.dataset.k); }); });
  $$('#seg button').forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.k); }); });
  $$('#pk .pkc').forEach(function (c) { c.addEventListener('click', function () { pick(c.dataset.k); }); });
  var tq = new URLSearchParams(location.search).get('variant');
  var t0 = tiers.filter(function (t) { return tq && t.dataset.variant === tq; })[0] || tiers.filter(function (t) { return t.classList.contains('sel'); })[0];
  if (t0) pick(t0.dataset.k);

  /* add to cart, then Elixir's drawer (or the cart page) */
  var cta = $('#buy-cta');
  if (cta) cta.addEventListener('click', function (e) {
    e.preventDefault();
    if (!sel || !sel.dataset.variant) return;
    var id = sel.dataset.variant, props = {};
    var gift = $('[data-slot="p1-gift-toggle"] input');
    if (gift && gift.checked) props['Gift'] = 'Yes, no price on the packing slip';
    cta.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw r; })
      .then(function () {
        var d = document.querySelector('cart-drawer');
        if (d && d.refreshCartDrawer) return d.refreshCartDrawer().then(function () { if (d.classList.contains('is-empty')) d.classList.remove('is-empty'); d.open && d.open(cta); });
        location.href = '/cart';
      })
      .catch(function () { location.href = '/cart/add?id=' + id + '&quantity=1'; })
      .then(function () { cta.removeAttribute('aria-busy'); });
  });

  /* sticky: on once the buy-box CTA has scrolled above the viewport */
  var sticky = $('#sticky');
  function st() { if (sticky && cta) sticky.classList.toggle('on', cta.getBoundingClientRect().bottom < 0); }
  addEventListener('scroll', st, { passive: true }); addEventListener('resize', st); st();

  /* dates */
  var buy = $('#s1');
  var door = new Date(), left = buy ? +buy.dataset.doorDays || 7 : 7;
  while (left > 0) { door.setDate(door.getDate() + 1); if (door.getDay() % 6) left--; }
  $$('.js-door').forEach(function (e) { e.textContent = DAYS[door.getDay()] + ', ' + MON[door.getMonth()] + ' ' + door.getDate(); });
  /* launch gifts: a fixed date (YYYY-MM-DD), or "sunday" = the Sunday of the current week in New York,
     today on a Sunday (rolling, never out of date; William, 2026-10-29) */
  var dl = buy && buy.dataset.deadline, d = null;
  if (dl === 'sunday') {
    try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
    d.setDate(d.getDate() + (7 - d.getDay()) % 7);
  } else if (dl && /^\d{4}-\d{2}-\d{2}$/.test(dl)) {
    var p = dl.split('-'); d = new Date(+p[0], +p[1] - 1, +p[2]);
  }
  if (d) $$('.js-deadline').forEach(function (e) { e.textContent = DAYS[d.getDay()] + ', ' + MONTH[d.getMonth()] + ' ' + d.getDate(); });
})();
